import { Injectable, EventEmitter } from '@angular/core';

import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { CookieService } from 'ngx-cookie-service';

import { Http, Response, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/toPromise';


@Injectable()
export class ConstantService {
    private selectedLanguage: { languageName: string, languageId: string } = { languageName: "EnglishUS", languageId: "0" };
    private selectedCompany: { companyName: string, companyCode: string };
    private app_data: any;
    // private headers: Headers;
    //private username: string = "";
    // private password: string = "";
    private username: string = "staticuser";
    private password: string = "s3cur1ty";

    dataUpdated = new EventEmitter<any>();

    constructor(private http: Http, private cookieService: CookieService) {

    }

    getData(): any {
        this.subscribe(this.selectedLanguage);
    }
    subscribe(language: any) {
        this.getLanguageObjFromAppDataByLang(language).then(data => { this.dataUpdated.emit(data); });
    }

    getLanguageObjFromAppDataByLang(lang: any): Promise<Object> {
        return this.getAppData().then(appData => {
            let langArr = appData.data.setup_info;
            for (var i = 0; i < langArr.length; i++) {
                var obj = langArr[i];

                if (obj.languageId === lang.languageId) {
                    return obj;
                }
            }
            throw "LanguageName should match in the AppData, language is: " + lang.languageName;
        });
    }
    public getAllLanguages(): Promise<Array<{ languageName: string, languageId: string }>> {
        return this.getAppData().then(appData => {
            let ttLanguages = appData.data.setup_info;
            var languages = [];
            for (var i = 0; i < ttLanguages.length; i++) {
                var obj = ttLanguages[i];
                var langObj = {};
                langObj['languageName'] = obj.languageName;
                langObj['languageId'] = obj.languageId;
                languages.push(langObj);
            }

            return languages;
        });

    }


    public setLanguage(language: any) {
        this.selectedLanguage = language;
        this.cookieService.set('cdi_selectedLanguage', JSON.stringify(language));
        this.getData();
    }

    public getSelectedLanguage(): { languageName: string, languageId: string } {
        
        
        return this.selectedLanguage;
    }


    public setCompany(company: any) {
        this.selectedCompany = company;
        this.cookieService.set('cdi_selectedCompany', JSON.stringify(company));
    }

    public getSelectedCompany(): { companyName: string, companyCode: string } {
        return this.selectedCompany;
    }

    init() {
        let cookieValue = this.cookieService.get('cdi_selectedLanguage');
        if (cookieValue !== "") {
            this.selectedLanguage = JSON.parse(cookieValue);
        }

    }


    private getAppData(): Promise<any> {

        if (typeof (this.app_data) === "undefined") {
            return this.http.get('assets/lang.json')
                .toPromise().then(res => {
                    this.app_data = res.json().response;
                    return this.app_data;
                })
                .catch(this.handleError);
        } else {
            return Promise.resolve(this.app_data);
        }
    }

    //comment
    //   private getAppData() : Promise<any> {

    //     if(typeof(this.app_data) === "undefined") {

    //   //  let headers = new Headers();
    //   //  headers.append("Authorization", "Basic " + btoa(this.username + ":" + this.password));

    //     let options = new RequestOptions({
    //             //    headers: headers
    //               });

    //      let url = "http://196.42.42.128:8080/CDIBackendServices/rest/orderprocessingservice/systemsetup";


    //     return this.http.get(url, options)
    //             .toPromise().then(res => {
    //                                  this.app_data = res.json().response;
    //                                  return this.app_data;
    //                          })
    //             .catch(this.handleError);
    //     } else {
    //       return Promise.resolve(this.app_data);
    //     }
    //   }
    //comment
    //   public getLangLabelByLableName(lableName:string, languages: any) {
    //       let ttLiterals = languages.literals;
    //       for(var i = 0; i < ttLiterals.length; i++) {
    //         var obj = ttLiterals[i];

    //        // if(obj.labelName === lableName){
    //        //   return obj.langLabel;
    //       //  }
    //        return obj[lableName];
    //       }
    //   }
    public getLangLabelByLableName(lableName: string, languages: any) {

        let ttLiterals = languages.literals;
        return ttLiterals[lableName];
    }
    private handleError(error: Response) {
        return Observable.throw(error.json().error || 'Server error');
    }

    public getAllCompanies(): Promise<Array<{ companyName: string, companyCode: string }>> {
        return this.getAppData().then(appData => {
            let ttCompanies = appData.companies.Company;
            return ttCompanies;
        });

    }

}


// WEBPACK FOOTER //
// ./src/app/providers/language.service.ts